import originJSONP from "fetch-jsonp";
import { Toast } from "vant";
/**
 * 拼接参数
 *
 * @param {object} data
 * @returns
 */
const param = (data) => {
	let url = "";
	for (var k in data) {
		let value = data[k] !== undefined ? data[k] : "";
		url += `&${k}=${encodeURIComponent(value)}`;
	}
	return url ? url.substring(1) : "";
};

/**
 * 封装jsonp
 *
 * @param {string} url              请求url
 * @param {object} [data=null]      请求参数
 * @param {object} option           jsonp的option
 * @param {object} type            默认0 vps接口 判断不同接口调用; 1 -> api接口; 2 -> service接口
 * @returns
 */

const Jsonp = (url, data = null, val, option) => {
	let query = "?"; // 默认传递参数
	// 判断是否要带参数
	if (data && Object.keys(data).length) {
		query += "&";
		query += param(data);
	}
	url += query;
	// 后端约定的jsoncallback（回调函数名称）
	option = Object.assign(
		{},
		{
			// jsonpCallback: option || 'jsoncallback',
			jsonpCallback: option || "jsoncallback",
			timeout: 8000,
			jsonpCallbackFunction: val || "",
		},
		option
	);
	// 这里返回一个promise对象
	return originJSONP(url, option).then(
		// 成功返回数据
		(res) => res.json(),
		// 请求发生错误或超时
		() => {
			// Toast({
			// 	message: "请求服务失败！",
			// });
		}
	);
	// return originJSONP(url, option)
	// 	.then((res) => {
	// 		let json = res.json();
	// 		console.log(json);
	// 		return res.json().then((data) => {
	// 			console.log(data);
	// 			if (data.returnCode === "0000" || data.code === "0000") {
	// 				return json;
	// 			} else {
	// 				Toast.fail("请求失败，请稍后再试");
	// 				return false;
	// 			}
	// 		});
	// 	})
	// 	.catch((err) => {
	// 		console.log(err);
	// 		Toast.fail("请求失败，请稍后再试");
	// 	});
};

// github jsonp 参考链接
// https://github.com/webmodules/jsonp

export default Jsonp;
